import { render, staticRenderFns } from "./VinculosEnderecosForm.vue?vue&type=template&id=0b5374b5&"
import script from "./VinculosEnderecosForm.vue?vue&type=script&lang=js&"
export * from "./VinculosEnderecosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports